// all the localStorageInfo
export enum localStorageKey {
  remember = "remember", //
}
